import React from 'react';
import { useTranslation } from 'react-i18next';
import Layout from 'components/Layout';
import HelpBanner from 'components/Help/HelpBanner';
import ListTip from 'components/Help/ListTip';
import { SContact, SYoutubeBanner, SYoutubeBannerLink, SYoutubeBannerSubtitle, SYoutubeBannerTitle } from './styles';
import youtubeChannelBanner from 'images/YoutubeChannelBanner.webp';

const YOUTUBE_CHANNEL_URL = 'https://www.youtube.com/@MJB-q9i/videos';

const HelpPage = () => {
    const { t } = useTranslation();

    return (
        <Layout pageTitle={t('page.help.meta-title')} topBanner={<HelpBanner />}>
            <SYoutubeBannerLink href={YOUTUBE_CHANNEL_URL} rel="noopener noreferrer" target="_blank">
                <SYoutubeBannerTitle>{t('page.help.youtube-banner-title')}</SYoutubeBannerTitle>
                <SYoutubeBannerSubtitle>{t('page.help.youtube-banner-subtitle')}</SYoutubeBannerSubtitle>
                <SYoutubeBanner alt={t('page.help.youtube-banner-alt')} src={youtubeChannelBanner} />
            </SYoutubeBannerLink>
            <ListTip />
            <p>{t('page.help.text')}</p>
            { }
            <SContact dangerouslySetInnerHTML={{ __html: t('page.help.contact') }} />
        </Layout>
    );
};

export default HelpPage;
